import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './SelectableButton.module.scss';

const SelectableButton = forwardRef(
  ({
    label, value, defaultChecked, checked, disabled, name, id, onChange,
  }, ref) => (
    <span
      className={styles.selectableButton}
      tabIndex="0"
      role="checkbox"
      aria-checked={checked}
      aria-label={value}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onChange();
        }
      }}
    >
      <input
        className={styles.buttonInput}
        role="button"
        id={id}
        ref={ref}
        value={value}
        name={name}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        type="checkbox"
        aria-hidden="true"
        checked={checked}
        aria-labelledby={`${id}-label`}
      />
      <label data-qa="checkbox-label" className={checked ? styles.selectedButtonLabel : styles.unselectedButtonLabel} htmlFor={id} id={`${id}-label`}>
        {label}
      </label>

    </span>
  ),
);

SelectableButton.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectableButton;
